import React, { useEffect, useState, useCallback, lazy, Suspense } from 'react';
import './App.css';
import SplashScreen from './components/SplashScreen';
import SiteNav from './components/SiteNav';
import WhatsAppFloat from './components/WhatsAppFloat';
import StickyCta from './components/StickyCta';
import LeadModal from './components/LeadModal';
import HeroSplit from './heroes/HeroSplit';

/* Below-fold sections — lazy-loaded for faster initial paint.
   Pitch is lazy too: it pulls in gsap + the lordicon/lottie player,
   which we keep out of the initial (LCP-critical) bundle. */
const Pitch = lazy(() => import('./sections/Pitch'));
const ProcessNav = lazy(() => import('./sections/ProcessNav'));
const About = lazy(() => import('./sections/About'));
const Values = lazy(() => import('./sections/Values'));
const ProjectsNav = lazy(() => import('./sections/ProjectsNav'));
const Services = lazy(() => import('./sections/Services'));
const Faq = lazy(() => import('./sections/Faq'));
const Footer = lazy(() => import('./sections/Footer'));

function App() {
  const [splashDone, setSplashDone] = useState(false);
  const [leadOpen, setLeadOpen] = useState(false);
  const openLead = useCallback(() => setLeadOpen(true), []);
  const closeLead = useCallback(() => setLeadOpen(false), []);

  useEffect(() => {
    if (!splashDone) return;
    const params = new URLSearchParams(window.location.search);
    const target = params.get('scroll');
    const offset = parseInt(params.get('offset') || '0', 10);
    const y0 = parseInt(params.get('y') || 'NaN', 10);
    if (!Number.isNaN(y0)) {
      window.scrollTo(0, y0);
      setTimeout(() => window.scrollTo(0, y0), 200);
      setTimeout(() => window.scrollTo(0, y0), 600);
      return undefined;
    }
    if (target) {
      const doScroll = () => {
        const el = document.getElementById(target);
        if (el) {
          const rect = el.getBoundingClientRect();
          const y = rect.top + window.scrollY + offset;
          window.scrollTo(0, y);
        }
      };
      doScroll();
      const id1 = setTimeout(doScroll, 100);
      const id2 = setTimeout(doScroll, 500);
      return () => { clearTimeout(id1); clearTimeout(id2); };
    }
    return undefined;
  }, [splashDone]);

  return (
    <div className="App">
      {!splashDone && <SplashScreen onDone={() => setSplashDone(true)} />}
      <SiteNav />
      <WhatsAppFloat />
      <StickyCta onOpenLead={openLead} />
      <LeadModal open={leadOpen} onClose={closeLead} />
      <main>
        <HeroSplit onOpenLead={openLead} />
        <Suspense fallback={null}>
          <Pitch onOpenLead={openLead} />
          <ProcessNav />
          <About />
          <Values onOpenLead={openLead} />
          <Services onOpenLead={openLead} />
          <ProjectsNav />
          <Faq />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;
